<template>
  <div class="bottom-breathing-space">
    <div style="padding-bottom: 20px;">
      <!--
      <img v-show="brandLogo === 'dropsmart'" src="@/assets/images/dropsmart-logo.png" alt="Logo" class="logoCheckout" />  
      <img v-show="brandLogo === 'melanimethodNLAE'" src="@/assets/images/melani-method-nlae-bundle.jpeg" alt="Logo" class="logoCheckout" />
      <img src="@/assets/images/melani-method-nlae-bundle.jpeg" alt="Logo" :class="brandLogo === 'melanimethodNLAE' ? 'logoCheckoutMelaniMethod' : 'logoCheckout'" />
      -->
    
      <img v-show="brandLogo === 'melanimethod' || brandLogo === 'eoarchitectureworkshop'" src="@/assets/images/melani-method-logo.png" alt="Logo" class="logoCheckout" />
    </div>

    <b-row v-if="expirationDate">
      <b-col sm="12" class="time-counter-row header-checkout">
        <countdown :end-time="expirationDate">
          <template v-slot:process="expirationCountdown">
            <div class="time-counter">
              <div id="time-counter-container-2">
                <div>
                  <div class="value">{{ expirationCountdown.timeObj.d }}<span>|</span></div>
                  <div class="label">days</div>
                </div>
                <div>
                  <div class="value">{{ expirationCountdown.timeObj.h }}<span>:</span></div>
                  <div class="label">hours</div>
                </div>
                <div>
                  <div class="value">{{ expirationCountdown.timeObj.m }}<span>:</span></div>
                  <div class="label">minutes</div>
                </div>
                <div>
                  <div class="value">{{ expirationCountdown.timeObj.s }}</div>
                  <div class="label">seconds</div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:finish>
            <div style="margin: 0 0 4rem 0;">
            <a id="expired-offer-link" :href="linkExpiredOffer">I'M SORRY. THIS OFFER EXPIRED!</a>
            </div>
          </template>
        </countdown>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    expirationDate: {
      type: Number,
      required: true,
    },
    showTitleBlock: {
      type: Boolean,
      default: true,
    },
    linkExpiredOffer: {
      type: String,
      default: "https://center.dropsmarteo.com/checkout?period=yearly",
    },
    brandLogo: {
      type: String,
      default: "dropsmart",
    }
  },
}
</script>

<style scoped lang="scss" >

#expired-offer-link {
  font-size: 1.5rem;
  color: red;
  font-weight: 900;
}

#expired-offer-link:hover {
  color: red;
  text-decoration: underline;
}
#expired-offer-link:visited {
  color: red;
  text-decoration: none;
}

.bottom-breathing-space {
  margin-bottom: 20px;
}

#time-counter-container-2 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

#time-counter-container-2 div {
  width: 3em;
  font-size: 3rem;
  font-weight: 400;
}
#time-counter-container-2 span {
  float: right;
}
#time-counter-container-2 .value {
  height: 60px;
}
#time-counter-container-2 .label {
  font-weight: normal;
  font-size: 0.9rem;
  width: auto;
  text-align: center;
  text-transform: uppercase;
  color: #555;
}

.countdown-title-message {
  font-weight: bold;
  font-size: 2rem;
  width: auto;
  text-align: center;
  text-transform: uppercase;
  color: #122;
}

</style>
